var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeNavSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 139,
    viewBox: "0 0 94 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.3816 139.003C42.772 139.003 41.4672 138.6 41.4672 138.104C41.4672 137.608 42.772 137.205 44.3816 137.205C45.9911 137.205 47.2959 137.608 47.2959 138.104C47.2959 138.6 45.9911 139.003 44.3816 139.003Z",
    fill: "#F1722E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6979 134.745C33.6076 134.745 32.7237 134.47 32.7237 134.13C32.7237 133.79 33.6076 133.515 34.6979 133.515C35.7882 133.515 36.6721 133.79 36.6721 134.13C36.6721 134.47 35.7882 134.745 34.6979 134.745Z",
    fill: "#F1722E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4428 18.402C87.608 13.9603 91.594 17.8741 92.58 20.4415C95.0599 29.0052 85.9449 32.5018 81.2874 32.8696C81.2145 32.8753 81.1526 32.9199 81.1223 32.9868L80.4477 34.4731C80.3794 34.6236 80.1698 34.6312 80.0911 34.4859L79.6232 33.6223C79.6006 33.5809 79.5643 33.5487 79.5205 33.5315L78.948 33.3067C78.7853 33.2428 78.7769 33.0141 78.9347 32.9384L80.0144 32.4199C80.1736 32.3434 80.1699 32.0949 80.0211 31.9995C79.4133 31.6099 78.6246 30.7818 78.4822 29.4039",
    stroke: "#F1722E",
    strokeWidth: 1.15,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7754 33.7924L74.6004 33.1354C74.5667 33.0087 74.656 32.8764 74.7788 32.8322C76.876 32.0752 85.1916 23.3377 78.8919 16.1353C74.763 11.4146 68.9308 15.6253 67.9752 18.4704C66.2274 22.8036 70.7643 31.2731 73.3086 32.6698C73.408 32.7243 73.4526 32.8457 73.4043 32.9488L73.0017 33.8091C72.9245 33.9739 73.0949 34.168 73.2729 34.1348C73.7125 34.0529 74.2091 34.0412 74.5656 34.0526C74.7038 34.057 74.8111 33.9267 74.7754 33.7924Z",
    stroke: "#F1722E",
    strokeWidth: 1.15,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3029 29.0956C69.1174 29.2825 68.7652 29.5546 68.4679 29.7026C68.3385 29.7672 68.2653 29.9436 68.3415 30.0669L68.8147 30.8327C68.9082 30.9838 68.7744 31.1735 68.6017 31.1347L68.0556 31.0117C67.9835 30.9954 67.9084 31.0206 67.8603 31.0772L67.6224 31.3573C67.509 31.4908 67.2918 31.4236 67.2724 31.249L67.1645 30.2758C67.1525 30.1685 67.0603 30.0902 66.9532 30.0944C64.3563 30.1943 58.5609 28.705 57.1152 21.4257C56.6658 19.1629 58.3323 14.4323 64.4542 13.9177C65.5898 13.8222 68.287 14.2842 69.7128 15.8475",
    stroke: "#F1722E",
    strokeWidth: 1.15,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.614 29.5735L63.8533 30.472C63.8862 30.5955 63.7975 30.7181 63.6706 30.7246L63.3287 30.7419C63.2611 30.7453 63.1997 30.7831 63.1659 30.8422L62.9788 31.1689C62.89 31.3239 62.6592 31.2934 62.6132 31.1206L62.3435 30.1076C62.3167 30.0067 62.2187 29.9434 62.116 29.9592C59.6836 30.3327 54.3846 29.7981 51.2369 24.7763C48.0088 19.6269 51.2247 16.6447 53.2358 15.7974",
    stroke: "#F1722E",
    strokeWidth: 1.15,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.306 19.0885C55.0932 18.1647 50.0214 14.4466 52.6978 8.9782C55.4414 3.37285 65.5009 4.41056 65.6189 13.7552",
    stroke: "#F1722E",
    strokeWidth: 1.15,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2982 7.53938C66.2884 6.00056 72.6971 5.13774 74.4097 13.9976",
    stroke: "#F1722E",
    strokeWidth: 1.15,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9066 6.61499C66.9604 3.75672 71.5154 -1.09555 77.0258 1.99077C82.2596 4.92217 80.2057 11.853 77.6821 14.8705",
    stroke: "#F1722E",
    strokeWidth: 1.15,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3395 6.91803C83.991 5.52741 91.517 7.85094 88.5327 16.7326",
    stroke: "#F1722E",
    strokeWidth: 1.15,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3471 101.63C44.9922 93.777 41.4936 90.5237 37.7785 88.1727C34.0645 85.8216 25.0642 82.931 26.6733 78.1905C28.2814 73.45 40.077 83.0082 47.3525 79.4238",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2157 102.703C59.2626 83.3225 64.6122 89.5219 69.4374 70.5597C70.5179 66.3136 66.8986 63.2013 64.6122 66.1204C63.3652 67.8314 60.5494 72.6409 59.2626 78.1908C57.9759 83.7407 56.7351 82.5846 56.2756 81.3127C56.1224 80.6189 55.5786 79.27 54.6289 79.4241",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9879 128.074C56.8378 123.154 60.755 107.007 61.4914 102.34C52.8893 109.53 45.2585 103.538 43.1127 101.63C41.9844 104.318 33.9807 115.254 34.1812 118.945C34.5952 126.551 38.8499 124.4 41.1853 122.445C42.6418 121.357 46.3399 115.996 47.8123 113.598C48.6119 116.358 45.1338 121.924 44.8515 124.716C44.8515 128.916 47.6088 128.705 48.9879 128.074Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6526 129.015C48.3577 130.468 47.3813 133.879 44.8055 133.924C43.1715 133.872 43.7261 132.143 44.7496 129.247",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0225 124.857C38.6624 126.876 36.6253 130.251 35.4032 129.494C34.8266 129.136 34.3408 127.8 34.9803 125.189",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7268 61.5967C69.9014 61.822 70.091 62.3731 69.5656 62.8798C69.5267 62.9173 69.4839 62.9546 69.4369 62.9915C68.7547 63.5266 68.4189 63.0399 68.3364 62.7297",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6431 61.7632C67.4373 62.3006 67.8368 62.4412 68.0623 62.4443C68.1157 62.438 68.1801 62.4279 68.2523 62.4134C68.6474 62.3335 69.2776 62.1212 69.6475 61.6975C69.678 61.6627 69.7042 61.629 69.7268 61.5963C70.0292 61.1588 69.6599 60.9126 69.4196 60.8413",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0238 59.951C69.2467 59.9442 69.6589 60.0432 69.5252 60.4942C69.3916 60.9452 68.2635 61.5127 67.7161 61.7401C67.6922 61.7492 67.6678 61.7572 67.6431 61.7637C67.419 61.8232 67.1695 61.772 67.0892 61.4702C66.9757 61.0438 67.4797 60.7532 67.5964 60.6952",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3921 59.0343C67.6248 59.0647 67.8913 59.3306 67.4595 59.7343C67.0279 60.1381 67.2458 60.4703 67.4087 60.5859C67.6523 60.7065 68.326 60.6658 69.0725 59.5387C69.8192 58.4118 68.0704 58.3061 67.1027 58.3942",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5214 60.4966C65.8515 60.0485 66.5429 59.3592 66.6682 60.1874C66.7935 61.0154 66.3219 61.5177 66.0705 61.6653",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3747 64.2963C66.5405 64.0255 66.734 63.2338 66.1822 62.2334",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9186 59.9224C64.6189 60.9873 64.5322 62.8713 64.5073 66.1275",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1666 86.8624L45.7822 85.9123C46.3817 84.9864 47.5479 84.6167 48.5666 85.03L50.0322 85.6248C50.9466 85.9959 51.9944 85.7384 52.6362 84.9851L54.3197 83.0083",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6304 79.8802C53.975 78.8781 53.6611 78.2037 53.3547 78.0752C51.5165 79.771 48.7285 79.1415 47.6946 78.1137C47.3265 78.4529 47.5409 79.4562 47.6946 79.7645C49.6859 81.9844 52.5197 80.7408 53.6304 79.8802Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9109 64.1247C58.0683 67.1695 57.6471 67.4392 56.4217 68.7882C56.4217 67.455 56.194 65.2174 56.194 64.2856C52.1815 64.2856 48.795 62.6371 47.6038 61.8129C47.6467 64.6081 45.042 66.4359 45.042 66.4359C45.042 66.4359 45.4161 67.5647 45.6296 70.0913C45.8002 72.1124 45.3093 71.7218 45.042 71.2739C44.2738 68.7796 43.0149 69.4461 42.4811 70.0913C35.9339 59.3841 46.0027 57.3153 47.924 57.5124C49.3748 56.2653 51.399 55.288 52.8218 55.1446C57.9535 54.6277 60.277 59.1878 58.9109 64.1247Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1317 73.1798C45.8211 77.4151 50.448 80.4606 53.7868 77.0297C57.1256 73.5989 56.4575 67.3188 56.1008 64.3882",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4054 69.8286C41.9844 70.8691 42.3795 73.1751 45.1318 73.1751",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6194 70.4009C43.5585 70.6236 43.6074 71.1512 44.2897 71.4801",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0081 72.6357C56.9065 72.2588 57.5399 70.8628 57.2963 68.6274",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9923 69.924C54.2473 69.8209 54.347 69.4688 54.2148 69.1377C54.0826 68.8066 53.7687 68.6217 53.5135 68.7249C53.2584 68.8281 53.1588 69.1802 53.291 69.5113C53.4231 69.8424 53.7371 70.0272 53.9923 69.924Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3077 70.0569C49.5665 69.9637 49.6872 69.6372 49.577 69.3276C49.4669 69.0182 49.1678 68.8429 48.9089 68.9362C48.65 69.0295 48.5295 69.356 48.6396 69.6655C48.7497 69.9749 49.0488 70.1502 49.3077 70.0569Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2766 68.5505C47.3973 68.1923 47.9191 67.5297 49.0383 67.7446",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6379 67.8572C52.9048 67.6245 53.6308 67.2988 54.3995 67.8572",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M51.964 69.5254C52.0532 70.2865 52.6386 71.915 51.6429 71.915",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1133 65.241C67.1133 63.9692 66.7686 59.0744 66.2325 55.5672C65.0306 47.7048 75.8447 44.4673 78.3723 35.4102",
    stroke: "#F1722E",
    strokeWidth: 1.15,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2238 33.5986C68.2238 37.0211 66.5006 52.8307 66.8834 59.8066C66.7942 60.8216 66.9294 63.2291 68.1855 64.7399",
    stroke: "#F1722E",
    strokeWidth: 1.15,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M66.692 59.7679C66.4623 59.0743 64.7879 57.4556 64.2411 55.1816C62.2114 46.7411 65.8878 41.0216 63.7432 32.3267",
    stroke: "#F1722E",
    strokeWidth: 1.15,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6619 35.2178C72.9981 38.9563 70.8816 47.9287 67.7261 53.9103C64.5705 59.8919 68.5047 65.2157 70.8663 67.1299",
    stroke: "#F1722E",
    strokeWidth: 1.15,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4402 73.6816C52.504 74.1441 52.0572 75.3774 50.602 74.6066",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2158 78.0869C20.2707 78.4539 20.8054 79.2827 22.5073 79.6623C24.2092 80.0419 25.1928 79.6659 25.4722 79.4303",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2581 76.7568C18.9847 76.9155 18.7254 77.3721 19.8716 77.9298L20.2158 78.0876L20.8143 78.3619",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8586 75.9365C19.5753 75.8163 18.9967 75.7136 18.9538 76.2639C18.9409 76.43 19.0626 76.5976 19.2581 76.7567C19.71 77.1248 20.559 77.4472 21.0627 77.5975",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9749 77.5302C25.7833 76.8917 25.3673 75.5883 24.6171 75.0781C24.4236 74.9537 24.0425 74.6286 24.0655 74.3242C24.0944 73.9436 23.2544 73.8927 23.3532 74.7442C23.4519 75.5956 24.1054 75.7088 23.5008 76.0397C23.017 76.3045 21.3999 75.6182 20.6517 75.242C20.3933 75.099 19.8466 74.9535 19.7209 75.5164C19.69 75.6558 19.7458 75.7979 19.8586 75.9366C20.2008 76.3578 21.0607 76.746 21.5615 76.922",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0667 131.505C19.8935 130.953 17.0394 129.886 15.0023 130.027C14.714 130.039 14.277 130.16 14.8436 130.555C15.4093 130.949 15.6916 131.153 15.7624 131.205C16.0567 131.452 16.346 131.974 15.1439 132.086C13.6405 132.227 9.39775 130.695 0.999977 131.822",
    stroke: "#F1722E",
    strokeWidth: 1.15,
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7574 111.446C65.2634 110.264 65.8693 107.13 64.2451 104.04",
    stroke: "#F1722E",
    strokeWidth: 1.15,
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4837 105.671C66.632 105.189 66.7787 103.912 66.1797 102.664",
    stroke: "#F1722E",
    strokeWidth: 1.15,
    strokeLinecap: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9783 128.102V125.943",
    stroke: "#F1722E",
    strokeWidth: 1.15,
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9088 127.142L68.7312 128.101",
    stroke: "#F1722E",
    strokeWidth: 1.15,
    strokeLinecap: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1925 128.101L66.309 126.697",
    stroke: "#F1722E",
    strokeWidth: 1.15,
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M23.003 119.392V116.848",
    stroke: "#F1722E",
    strokeWidth: 1.15,
    strokeLinecap: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2626 118.261L23.8849 119.392",
    stroke: "#F1722E",
    strokeWidth: 1.15,
    strokeLinecap: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0842 119.391L21.0497 117.736",
    stroke: "#F1722E",
    strokeWidth: 1.15,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeNavSvg);
export default __webpack_public_path__ + "static/media/homeNavSvg.7709b551.svg";
export { ForwardRef as ReactComponent };